import React, { useState, useEffect } from 'react'
import { ContentBox } from '../../ContentBox'
import { ListBox, setTD, TableListTitle } from '../../../../../item/ItemTableList'
import { SingleButton, Space } from '../../../Res/BaseButton'
import { api_getBallsLoss, api_setBallsLoss } from '../../../../../api/MyStat/apiGame'
import { getKey } from '../../../../../item/ItemTools'
import { BallModifyEdit } from './BallModifyEdit'
import { SingleSelect } from '../../../Res/BaseInput'

export const BallModifyList = ({id, setIsLoading}) => {
  const titles = [
    new TableListTitle("投球編號", 0), new TableListTitle("日期", 0), new TableListTitle("局數", 0), new TableListTitle("投手", 0),
    new TableListTitle("打者", 0), new TableListTitle("B-S-O", 0), new TableListTitle("壘上狀況", 0), new TableListTitle("投球結果", 0),
    new TableListTitle("球種", 0), new TableListTitle("球速", 0), new TableListTitle("進壘點", 0), new TableListTitle("NON-BIP", 0),
    new TableListTitle("擊球型態", 0), new TableListTitle("擊球強度", 0), new TableListTitle("觸擊標籤", 0), new TableListTitle("擊球標籤", 0),
    new TableListTitle("擊球結果", 0), new TableListTitle("落點", 0)
  ]

  let currentTime = new Date()
  const [page, setPage] = useState(1)
  const [list_obj, setListObj] = useState({titles, contents: []})
  const [target, setTarget] = useState("ZoneLoss")
  const [modifyList, setModifyList] = useState([])
  const [count, setCount] = useState(0)
  const [selectedEdit, setSelectedEdit] = useState(undefined)
  const [year, setYear] = useState(currentTime.getFullYear())
  const [month, setMonth] = useState(currentTime.getMonth()+1)
  let initYearArr = [{ val: 2021, name: '2021' }, { val: 2022, name: '2022' }]
  let monthArr = [{val: 1, name: 1}, {val: 2, name: 2}, {val: 3, name: 3}, {val: 4, name: 4}, {val: 5, name: 5}, {val: 6, name: 6}, {val: 7, name: 7}, {val: 8, name: 8}, {val: 9, name: 9}, {val: 10, name: 10}, {val: 11, name: 11}, {val: 12, name: 12}]
  const [yearArr, setYearArr] = useState(initYearArr)

  useEffect(() => {
    let yarr = [...yearArr]
    if (currentTime.getFullYear() > 2022) {
      for (let i=2023; i<=currentTime.getFullYear(); i++) {
        yarr.push({val: i, name: `${i}`})
      }
    }
    setYearArr(yarr)
  }, [])

  
  const toSearchFromPage = ({ page = 1 }) => {
    setPage(page)
    setIsLoading(true)
    api_getBallsLoss({
      payload: { "API_Type": target, "Year": parseInt(year), "Month": parseInt(month), "Start": (page-1)*25, "Limit":25 }, 
      success: (obj) => {
        // console.log("Successfully get ", target, " items")
        setModifyList(obj.items.slice((page-1)*25, page*25))
        setCount(obj.count || obj.items.length)
        setIsLoading(false)
      }, 
      failure: (err) => { console.log(err); setIsLoading(false); }
    })
  }
  const baseContent = (
    <>
      <ListBox row={18} lt={25} lb={list_obj} count={count} page={page} sp={toSearchFromPage} />
    </>
  )

  const apiFetchLoss = () => {
    setIsLoading(true)
    console.log({ "API_Type": target, "Year": parseInt(year), "Month": parseInt(month), "Start": 0, "Limit":25 })
    api_getBallsLoss({
      payload: { "API_Type": target, "Year": parseInt(year), "Month": parseInt(month), "Start": 0, "Limit":25 }, 
      success: (obj) => {
        console.log("Successfully get ", target, " items", obj)
        setModifyList(obj.items.slice(0, 25))
        setCount(obj.count || obj.items.length)
        setIsLoading(false)
      }, 
      failure: (err) => { console.log(err); setIsLoading(false); }
    })
  }

  useEffect(() => {
    // console.log(list_obj)
    apiFetchLoss()
  }, [target])

  useEffect(() => {
    setListObj({titles: list_obj.titles, contents: wrapListContents(modifyList)})
  }, [modifyList, selectedEdit])

  const setEdit = (initVal, editVal) => {
    // console.log(editVal)
    if (editVal === initVal) {
      setSelectedEdit(undefined)
    } else {
      setSelectedEdit(editVal)
    }
  }

  const handleCloseBox = () => {
    setSelectedEdit(undefined)
  }

  const handleSaveData = (payload, pid) => {
    api_setBallsLoss({
      payload: payload,
      success: (obj) => {
        if (obj.status) {
          console.log("success", obj)
          let newList = modifyList.filter((e)=>(e.Pitch_ID !== pid))
          setModifyList(newList)
          setCount(count-1)
        } else {
          console.log('fail', obj.message)
        }
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  const wrapListContents = (list) => {
    const contents = []
    for (const e of list) {
      let content = []
      content.push(setTD({ content: e.Pitch_ID, action: setEdit, actionKey: selectedEdit, actionVal: e.Pitch_ID}))
      content.push(setTD({ content: e.Date }))
      content.push(setTD({ content: `${e.Inning} ${e['Top/Bottom']}`}))
      content.push(setTD({ content: e.Pitcher }))
      content.push(setTD({ content: e.Batter }))
      content.push(setTD({ content: `${e.Balls}-${e.Strikes}-${e.Outs}` }))
      content.push(setTD({ content: e['On-Base'] }))
      content.push(setTD({ content: e.PitchCode }))
      content.push(setTD({ content: e.TaggedPitchType }))
      content.push(setTD({ content: e.APP_VeloRel }))
      content.push(setTD({ content: `(${e.APP_KZoneY}, ${e.APP_KZoneZ})` }))
      content.push(setTD({ content: e.KorBB }))
      content.push(setTD({ content: e.HitType }))
      content.push(setTD({ content: e.HardnessTag }))
      content.push(setTD({ content: e.BuntTag }))
      content.push(setTD({ content: e.HitTag }))
      content.push(setTD({ content: e.PlayResult }))
      content.push(setTD({ content: `(${e.LocX}, ${e.LocY})` }))
      contents.push(content)
      if (selectedEdit === e.Pitch_ID) {
        // console.log("hit")
        contents.push([<td key={getKey({})} colSpan={18}><BallModifyEdit setIsLoading={setIsLoading} initData={e} handleCloseBox={handleCloseBox} handleSaveData={handleSaveData} /></td>])
      }
    }
    return contents
  }

  const ChangeButton = ({name, action}) => {
    return <button className='mdlist-change-button' onClick={action}>{name}</button>
  }

  const targetNameMap = {
    "ZoneLoss": "進壘點缺失",
    "LocLoss": "落點缺失",
    "PitchTypeLoss": "球種缺失",
    "HardTLoss": "擊球強度缺失",
    "HitTLoss": "擊球型態缺失",
  }


  return (
    <div className='element-to-print'>
        <div className='mdlist-selects'>
          <SingleSelect title={"年份"} val={year} attr={yearArr} action={setYear} hasBlank={false} size={3} />
          <SingleSelect title={"月份"} val={month} attr={monthArr} action={setMonth} hasBlank={false} size={3} />
          <ChangeButton name="搜尋" action={() => {apiFetchLoss()}} />
        </div>
        <Space />
        <div className='mdlist-buttons'>
          <ChangeButton name="進壘點缺失" action={() => { setTarget("ZoneLoss")}} />
          <ChangeButton name="落點缺失" action={() => { setTarget("LocLoss") }} />
          <ChangeButton name="球種缺失" action={() => { setTarget("PitchTypeLoss") }} />
          <ChangeButton name="擊球強度缺失" action={() => { setTarget("HardTLoss") }} />
          <ChangeButton name="擊球型態缺失" action={() => { setTarget("HitTLoss") }} />
        </div>
      <ContentBox title={`BallModify List - ${targetNameMap[target]}`} content={baseContent} />
    </div>
  )
}